import { FlexColumn } from '@editor/components/utilities/layouts';
import { SubscriptionPlanType } from '@repo/subscription/api';
import { H5, P3 } from '@repo/ui/components/Typography';
import { hideScrollBar } from '@repo/ui/components/utilities';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

const HORIZONTAL_PADDING = '32px';
const HORIZONTAL_PADDING_MOBILE = '12px';

export const Wrapper = styled(FlexColumn)`
  width: 100%;
  overflow: hidden;
  padding: 12px ${HORIZONTAL_PADDING_MOBILE} 0px;
  flex-shrink: 0;

  ${QUERIES.largeTabletAndUp} {
    padding-bottom: 24px;
  }

  ${QUERIES.laptopAndUp} {
    padding: 12px ${HORIZONTAL_PADDING} 24px;
  }
`;

export const PlansContainer = styled.div<{ plan: SubscriptionPlanType }>`
  display: grid;
  flex-grow: 1;
  grid-template-columns: repeat(2, 100%);
  grid-gap: 36px;
  padding: 0 ${HORIZONTAL_PADDING_MOBILE};
  margin: 0 -${HORIZONTAL_PADDING_MOBILE};

  ${QUERIES.laptopAndUp} {
    padding: 0 ${HORIZONTAL_PADDING};
    margin: 0 -${HORIZONTAL_PADDING};
  }

  overflow-x: hidden;

  > div {
    width: 100%;
    margin: 24px 0;

    transition: transform 0.2s ease-out;
  }

  ${({ plan }) =>
    plan === SubscriptionPlanType.EXPERT &&
    `
      > :nth-child(1) {
        transform: translateX(calc(-100% - 36px));
      }

      > :nth-child(2) {
        transform: translateX(calc(-100% - 36px));
      }
  `}

  ${hideScrollBar}
`;

export const SelectButton = styled(H5).attrs(() => ({
  as: 'button',
}))<{ isActive: boolean }>`
  height: 33px;
  width: 50%;
  background-color: transparent;

  color: ${({ isActive }) =>
    isActive ? themeStyle.varInkMain : themeStyle.varInkMedium};
  text-align: center;
  line-height: 33px;
  border: none;
  border-bottom: 1px solid
    ${({ isActive }) =>
      isActive ? themeStyle.varInkMain : themeStyle.varInkLight};
  transition:
    color 0.3s,
    border-color 0.3s;

  cursor: pointer;
  &:focus,
  &:active {
    outline: none;
  }

  &:hover {
    color: ${themeStyle.varInkMain};
    border-color: ${themeStyle.varInkMain};
  }
`;

export const CompareLink = styled(P3)`
  cursor: pointer;
  color: ${themeStyle.varInkMedium};
  line-height: 15px;

  &:hover {
    color: ${themeStyle.varInkMain};
  }
`;
